// extracted by mini-css-extract-plugin
export default {"full-width-image":"FullWidthImage_full-width-image__RzGgM"};